<template>
  <table class="estimation-table">
    <tr class="tr -head">
      <th class="th" v-text="i18n.price"></th>
      <th class="th -flexible"></th>
      <th class="th" v-text="i18n.duration"></th>
      <th class="th" v-text="i18n.choose_priority"></th>
    </tr>
    <tr class="tr -line" v-for="priority in priorities" :key="priority.id">
      <td class="td estimation-bar -left">
        <span
          class="cost"
          v-html="priority.str.discounted + i18n.tax_excluded"
        ></span>
        <span class="credit" v-html="priority.str.render"></span>
      </td>
      <td class="td estimation-bar -center">
        <div class="container">
          <div
            class="left"
            :style="{
              'flex-grow':
                priority.amount.discounted - bestPrice.amount.discounted,
            }"
            :data-weight="
              priority.amount.discounted - bestPrice.amount.discounted
            "
          >
            .<!-- Hack for firefox -->
          </div>
          <div
            class="right"
            :style="{
              'flex-grow':
                worstPrice.amount.discounted - priority.amount.discounted,
            }"
            :data-weight="
              worstPrice.amount.discounted - priority.amount.discounted
            "
          >
            &nbsp;
          </div>
        </div>
      </td>
      <td class="td estimation-bar -right">
        <span class="duration" v-html="priority.str.duration"></span>
        <span
          v-if="priority.max_nodes"
          class="nodes"
          v-text="priority.max_nodes + ' ' + priority.str.nodes_unit + '**'"
        ></span>
      </td>
      <td class="pr-2">
        <div class="-mt-2">
          <ranch-button
            @click="$emit('priority-selected', priority)"
            class="w-full"
            :label="priority.priority"
            :icon-after="true"
            :icon="
              !selectedPriority || selectedPriority.id === priority.id
                ? 'arrow-right'
                : null
            "
            :action="
              !selectedPriority || selectedPriority.id === priority.id
                ? 'action border'
                : 'action-secondary border border-action'
            "
          />
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    i18n: Object,
    priorities: Array,
    bestPrice: Object,
    worstPrice: Object,
    selectedPriority: Object,
  },
};
</script>
